import { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { theme } from '_constants/theme';

const { colors, devices, fontSizes, spaces } = theme;

const StyledBanner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  position: relative;
`;

const StyledBannerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: ${spaces.large24X * 10 + 80}px;
  width: 100%;
  margin-top: ${spaces.large7X}px;
  @media ${devices.tablet} {
    margin-top: ${spaces.large}px;
    padding-left: 16px;
    padding-right: 16px;
  }
`;

const StyledBackImageContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: end;
  z-index: -1;

  @media ${devices.tablet} {
    img {
      width: 100%;
    }
  }
`;

// eslint-disable-next-line prettier/prettier, react/display-name
const StyledFrontImageContainer = styled(forwardRef(({ desktop, mobile, rightSpace, ...props }, ref) => (<div ref={ref} {...props} />)))`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: ${spaces.large7X}px;
  margin-bottom: ${spaces.large7X}px;
  picture {
    width: 100%;
    img {
      width: 100%;
    }
  }

  ${({ mobile }) =>
    mobile &&
    css`
      display: none;
    `}

  @media ${devices.tablet} {
    ${({ desktop }) =>
      desktop &&
      css`
        display: none;
      `}

    ${({ mobile }) =>
      mobile &&
      css`
        display: flex;
        margin-top: ${spaces.large}px;
        margin-bottom: ${spaces.large}px;
        img {
          width: 100%;
        }
      `}
  }
`;

const StyledButtonBlock = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  ${({ bottomText }) =>
    bottomText &&
    css`
      margin-top: ${spaces.large7X}px;
    `}

  @media ${devices.tablet} {
    ${({ bottomText }) =>
      bottomText &&
      css`
        margin-top: ${spaces.large}px;
      `}
    margin-bottom: ${spaces.large}px;
    button {
      width: 100%;
      justify-content: center;
    }
  }
`;

const StyledTitle = styled.div`
  font-family: 'Aeonik';
  font-style: normal;
  font-weight: 500;
  font-size: ${fontSizes.large11X}px;
  line-height: 130%;
  color: ${colors.indigo[800]};
  margin-bottom: ${spaces.medium}px;
  @media ${devices.tablet} {
    font-size: ${fontSizes.large8X}px;
    margin-bottom: ${spaces.small - 2}px;
    line-height: 140%;
  }
`;

const StyledText = styled.div`
  font-family: 'Aeonik';
  font-style: normal;
  font-weight: 400;
  font-size: ${fontSizes.medium}px;
  line-height: 150%;
  color: ${colors.gray[700]};
  text-align: center;
  @media ${devices.tablet} {
    /* text-align: left; */
    font-size: ${fontSizes.regular}px;
  }
`;

const MainBannerSection = ({
  title,
  topText,
  bottomText,
  buttonsBlock,
  backgroundImage,
  desktopImage,
  mobileImage,
}) => {
  return (
    <StyledBanner>
      <StyledBannerContainer>
        <StyledTitle>{title}</StyledTitle>
        <StyledText>{topText}</StyledText>
        {backgroundImage && (
          <StyledBackImageContainer>
            <picture>
              <source srcSet={backgroundImage} type="image/svg+xml" />
              <img src={backgroundImage} alt="" />
            </picture>
          </StyledBackImageContainer>
        )}
        {desktopImage && (
          <StyledFrontImageContainer desktop>
            <picture>
              <source srcSet={desktopImage} type="image/png" />
              <img src={desktopImage} alt="" />
            </picture>
          </StyledFrontImageContainer>
        )}
        {mobileImage && (
          <StyledFrontImageContainer mobile>
            <picture>
              <source srcSet={mobileImage} type="image/png" />
              <img src={mobileImage} alt="" />
            </picture>
          </StyledFrontImageContainer>
        )}
        {bottomText && <StyledText>{bottomText}</StyledText>}
        {buttonsBlock && (
          <StyledButtonBlock bottomText={bottomText}>
            {buttonsBlock}
          </StyledButtonBlock>
        )}
      </StyledBannerContainer>
    </StyledBanner>
  );
};

export default MainBannerSection;
